import { makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import React, { useContext } from 'react';
import { URLContext } from '../../contexts/URLContext';

const useStyles = makeStyles({
  table: {
    margin: "8px auto",
    width: "96%",
  },
  header: {
    fontWeight: "bold",
    backgroundColor: 'var(--lightbg)',
  },
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word",
    maxWidth: "240px",
  }
});

const validatePrize = (ticket) => {
  if(ticket.status === "opened") {
    if( ticket.prize > 0 ) {
      return (
        <b>R$ {ticket.prize},00</b>
      );
    }
    else {
      return "-";
    }
  }
  else {
    return "Bilhete fechado";
  }
}

/*const hideUUID = (uuid) => {
  let idArr = uuid.split('');
  let uuidHided = `${idArr[0]}${idArr[1]}${idArr[2]}${idArr[3]}...${idArr[idArr.length - 4]}${idArr[idArr.length - 3]}${idArr[idArr.length - 2]}${idArr[idArr.length - 1]}`;
  return uuidHided;
}*/

const TableTickets = (props) => {
  const {campaignData} = useContext(URLContext);
  const [ tickets, setTickets ] = React.useState([]);
  const classes = useStyles();

  React.useEffect(() => {
    setTickets(props.tickets);
  }, [props.tickets])

  return(
    <>
      <Typography variant="h6" component="h3" className="bold-text" align="center" gutterBottom>
        {campaignData && campaignData.ticketTitle}
      </Typography>
      <TableContainer className={classes.table} component={Paper}>
        <Table aria-label="simple table">
          <TableHead className={classes.header}>
            <TableRow>
              <TableCell className="bold-text primary--text">{campaignData && campaignData.balanceTitle}</TableCell>
              <TableCell className="bold-text primary--text">Prêmio</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            { tickets.map((ticket, index) => (
              <TableRow key={index}>
                <TableCell align="left" className={`${classes.customCell} primary-light--text`}>{ticket.invoice}</TableCell>
                <TableCell align="left" className={`${classes.customCell} primary-light--text`}>{validatePrize(ticket)}</TableCell>
              </TableRow>
            )) }
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TableTickets;